import { PermissionsEnum } from "@/auth/interfaces";
import { SaveFormDataPreagendamientoNoc } from "@/erp/noc/agendamientonoc/shared/components/SavePreagendamiento/ConfirmPreagendamiento";
import {
  EstadosLlamadaEnumChoice,
  EstadosPreagendamientoEnumChoice,
  ROUTER_PATHS,
  toHour,
  toHours,
  TrazabilidadAccionChoiceEnum,
  useLoaders,
} from "@/shared";
import {
  AprovePreagendamientoData,
  PreagendamientoOcupado,
  useUpdatePreagendamiento,
} from "@/shared/actions/erp";
import {
  CustomButtunsRejectConfirm,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  CacheKeyCalendarioENUM,
  ErrorMessagesForm,
  EstadoBitacoraEnum,
  IPreagendamiento,
} from "@/shared/interfaces";
import {
  calcTrazavilidadVendedor,
  convertirFormatoHoraArray,
  convertirHoraADecimalArray,
  handleErrorForm,
  hasPermission,
  preagendamientoFormSchema,
} from "@/shared/utils";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useBackDetection from "../../hooks/useBackDetection";
import { SaveFormDataPreagendamiento } from "../../interface/SaveFormDataPreagendamiento";
import { RejectPreagendaModal } from "../forms";
import PreagendamientoSinglePage from "./PreagendamientoSinglePage";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";
import { Grid } from "@mui/material";
import useSelectDateTimerPreScheduling, {
  DepartamentoSelectScheduling,
} from "@/erp/sale/component/calendario-preagendamiento-venta/useSelectDateTimerPreScheduling.store";
import { toast } from "react-toastify";
import { useAuthStore } from "@/store/auth";

export interface ConfirmPreagendamientoProps {
  title: string;
  preagendamiento?: IPreagendamiento;
}

const ConfirmPreagendamiento: React.FC<ConfirmPreagendamientoProps> = ({
  title,
  preagendamiento,
}) => {
  const navigate = useNavigate();
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;

  const isPyLAdmin = hasPermission(
    PermissionsEnum.pyl_administrator_permission,
  );

  ///* local state --------------------
  const [openRechazoModal, setOpenRechazoModal] = useState(false);
  const [shrink] = useState(true);

  ///* global state --------------------
  const setAlert = useUiStore((s) => s.setAlert);

  const getFloat = useSelectDateTimerPreScheduling((s) => s.getFloat);
  const setIsSave = useSelectDateTimerPreScheduling((s) => s.setIsSave);
  const handleValidDateHour = useSelectDateTimerPreScheduling(
    (s) => s.handleValidDateHour,
  );
  const blocked = useSelectDateTimerPreScheduling((s) => s.blocked);
  const selectFloat = useSelectDateTimerPreScheduling((s) => s.selectFloat);
  const isLoadingFloat = useSelectDateTimerPreScheduling(
    (s) => s.isLoadingFloat,
  );
  const selectDate = useSelectDateTimerPreScheduling((s) => s.selectDate);
  const slot = useSelectDateTimerPreScheduling((s) => s.slot);
  const setPreventa = useSelectDateTimerPreScheduling((s) => s.setPreventa);
  const unblockPlanification = useSelectDateTimerPreScheduling(
    (s) => s.unblockPlanification,
  );
  const setConfigParams = useSelectDateTimerPreScheduling(
    (s) => s.setConfigParams,
  );
  const emitFinalizarVenta = useDiccionarioMotivo((s) => s.emitFinalizarVenta);

  ///* form --------------------
  const form = useForm<SaveFormDataPreagendamiento>({
    resolver: yupResolver(preagendamientoFormSchema) as any,
    defaultValues: {
      estado: true,
      isRejecting: false,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = form;

  ///* mutations --------------------
  const updatePreagendamientoMutation =
    useUpdatePreagendamiento<AprovePreagendamientoData>({});

  const updatePreAgendamientoMutationOcupado =
    useUpdatePreagendamiento<PreagendamientoOcupado>({});

  ///* handlers --------------------

  const authId = useAuthStore((s) => s.user)?.id;

  const onSave = async (data: SaveFormDataPreagendamientoNoc) => {
    if (!preagendamiento) {
      toast.error("No se encontró el preagendamiento.");
      return;
    }

    if (!isValid) return;

    /* if (selectDate == null || slot == null || selectFloat == null)
      return toast.error(
        "Selecionar un técnico con fecha y hora de instalación.",
      ); */

    ///* validar si aun esta disponible fecha de instalacion
    if (
      data.estado_llamada === EstadosLlamadaEnumChoice.REALIZADA &&
      !data.isRejecting
    ) {
      const esValid = await handleValidDateHour(authId);
      if (!esValid) return;
    }

    // evitar que se desbloquee el planificador mientras se guarda
    setIsSave(true);

    /* if(data.estado_llamada == EstadosLlamadaEnumChoice.REALIZADA){

    } */

    const dataForm = {
      celular: data.celular!,
      celular_2: data.celular_2!,
      email: data.email!,
      direccion: data.direccion!,
      coordenadas: data.coordenadas!,

      // estado llamada ----
      estado_llamada: data.estado_llamada!,
      fecha_hora_llamada: dayjs().format(),
      nap: data.nap,
      distancia: data.distancia,
      observaciones: {
        ...preagendamiento?.preventa_data?.observaciones,
        observacion_llamada: data.observacion_llamada!,
        observacion_rechazo: data.observacion_rechazo || "",
      },
      pais: data.pais!,
      ciudad: data.ciudad!,
      provincia: data.provincia!,
      zona: data.zona!,
      sector: data.sector!,
      persona_referencia_celular: data.persona_referencia_celular,
      persona_referencia_nombre: data.persona_referencia_nombre!,
      persona_referencia_parentesco: data.persona_referencia_parentesco!,

      estado_preagendamiento: data?.isRejecting
        ? EstadosPreagendamientoEnumChoice.PRERECHAZADO
        : data.estado_llamada === EstadosLlamadaEnumChoice.NO_CONTESTA ||
            data.estado_llamada === EstadosLlamadaEnumChoice.MENSAJE_WHATSSAPP
          ? EstadosPreagendamientoEnumChoice.EN_PAUSA
          : EstadosPreagendamientoEnumChoice.FINALIZADO,

      // observacion_rechazo: data.observacion_rechazo || null,
      motivo_rechazo: data.motivo_rechazo || null,
      user_gestionando: null,
      ///* Cambio de flota y hora de instalacion
      flota: blocked ? selectFloat : data.flota,
      fecha_instalacion: blocked
        ? selectDate.format("YYYY-MM-DD")
        : data.fecha_instalacion,
      hora_instalacion: blocked ? toHour(slot!.hora) : data.hora_instalacion!,
      fecha_instalacion_original: preagendamiento?.fecha_instalacion!,
      hora_instalacion_original: preagendamiento?.hora_instalacion!,
      //horas: bloquear ? convertirFormatoHoraArray(horasSelect) : data.horas
      /* horas: convertirFormatoHoraArray(
        blocked
          ? horasSelect
          : convertirHoraADecimalArray(data.hora_instalacion)
      ), */
      horas: convertirFormatoHoraArray(
        blocked
          ? toHours(slot!.hora)
          : convertirHoraADecimalArray(data.hora_instalacion),
      ),
    };

    ///* Envío de Pyl a Gestión Ventas desde cualquier estado se cierra bitacora automaitco

    if (
      data.estado_llamada == EstadosLlamadaEnumChoice.REALIZADA ||
      openRechazoModal
    ) {
      emitFinalizarVenta({
        numero_referencia_venta: preagendamiento?.id_preagendamiento!,
        estado_venta: EstadoBitacoraEnum.FINALIZADO,
      });
    }

    ///* upd
    const resp = await updatePreagendamientoMutation.mutateAsync({
      id: preagendamiento.id_preagendamiento!,
      data: dataForm as any,
    });

    if (resp.code == 200) {
      navigate(returnUrlAgendamientosPyLPage);
    }
  };

  const onCancel = async (preagendamiento: IPreagendamiento) => {
    updatePreAgendamientoMutationOcupado.mutate({
      id: preagendamiento?.id_preagendamiento!,
      data: {
        user_gestionando: null,
      },
    });

    navigate(returnUrlAgendamientosPyLPage);
  };

  const releasePreagendamiento = async () => {
    updatePreAgendamientoMutationOcupado.mutate({
      id: preagendamiento?.id_preagendamiento!,
      data: {
        user_gestionando: null,
      },
    });
  };

  ///* effects --------------------
  useBackDetection(releasePreagendamiento, preagendamiento!);

  ///* obtener los valores del preagendamiento

  useEffect(() => {
    if (!preagendamiento?.id_preagendamiento) return;

    const {
      preventa_data,
      prospecto_data,
      pais_data,
      provincia_data,
      ciudad_data,
      zona_data,
      sector_data,
      plan_data,
      flota_data,
      trazo_venta_data,
      ...rest
    } = preagendamiento;

    reset({
      ...prospecto_data,
      ...preventa_data,
      ...rest,
      nacionalidad: pais_data?.nacionalidad!,
      observacion_1: preventa_data?.observaciones.observacion_1 || "",
      observacion_2: preventa_data?.observaciones.observacion_2 || "",

      vendedor_name: calcTrazavilidadVendedor(
        trazo_venta_data || [],
        TrazabilidadAccionChoiceEnum.CREACION,
        "user",
      ),
      es_referido: !!preventa_data?.tipo_referido ? "SI" : "NO",
      planLabel: plan_data?.nombre!,
      velocidad_internet: preventa_data?.velocidad
        ? `${preventa_data?.velocidad} ${plan_data?.unidad}`
        : "",

      isRejecting: false,
      flota: rest.flota || "",
      flotaName: flota_data?.nombre || "",
      flotaRaw: flota_data,
      rawNap: rest.nap_data || {},
      observacion_llamada:
        preagendamiento.observaciones?.observacion_llamada || "",
      observacion_rechazo:
        preagendamiento.observaciones?.observacion_rechazo || "",
      // observacion_rechazo: data.observacion_rechazo || "",
    } as unknown as SaveFormDataPreagendamientoNoc);
  }, [preagendamiento, reset]);

  const user = useAuthStore((s) => s.user);

  // cargar planificador
  useEffect(() => {
    setConfigParams({
      time: 60 * 1000,
      tiempo: CacheKeyCalendarioENUM.TIEMPO_LIMITE_PYL,
      motivo: CacheKeyCalendarioENUM.MENSAJE_BLOQUEO_PYL,
      departamento:
        user?.departamento_nombre ?? DepartamentoSelectScheduling.PYL,
    });

    if (!preagendamiento) return;

    (async () => {
      await Promise.all([
        getFloat({
          estado: true,
          zonas: preagendamiento?.preventa_data?.zona,
          page_size: 100,
        }),
        setPreventa(preagendamiento?.preventa_data?.id_preventa),
      ]);
    })();

    return () => {
      unblockPlanification();
    };
  }, [preagendamiento?.id_preagendamiento]);

  useLoaders(isLoadingFloat);

  return (
    <>
      <SingleFormBoxScene
        py={2}
        titlePage={title}
        showCustomBtns={true}
        showActionBtns={false}
        num_referencia={`#${preagendamiento?.prospecto_data.razon_social} - L${preagendamiento?.contrato_data.linea}`}
        customBtns={
          <CustomButtunsRejectConfirm
            onCancel={() => onCancel(preagendamiento!)}
            onConfirm={() => {
              handleSubmit(onSave, (err) => {
                if (err?.estado_llamada || err?.observacion_llamada)
                  return setAlert(
                    true,
                    "El estado de llamada y su observación son requeridos",
                    AlertSeverityEnum.error,
                  );
                handleErrorForm(err as ErrorMessagesForm);
              })();
            }}
            rejectTextBtn="Enviar a Gestión Ventas"
            showRejectBtn={isPyLAdmin}
            onReject={() => {
              setOpenRechazoModal(true);
              form.reset({
                ...form.getValues(),
                isRejecting: true,
              });
            }}
            sxContainer={{
              pt: 0,
            }}
          />
        }
      >
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} margin={"15px 0px"}>
              <TipoVentaCanjeEvento
                prospecto_data={preagendamiento?.prospecto_data!}
              />
            </Grid>
            <Grid item xs={12}>
              <PreagendamientoSinglePage
                form={form}
                shrink={shrink}
                preagendamiento={preagendamiento!}
              />
            </Grid>
          </Grid>
        </>
      </SingleFormBoxScene>

      <RejectPreagendaModal
        open={openRechazoModal}
        onClose={() => {
          form.reset({
            ...form.getValues(),
            isRejecting: false,
          });
          setOpenRechazoModal(false);
        }}
        preagendamiento={preagendamiento!}
        form={form}
        onConfirm={() => {
          handleSubmit(onSave, (err) => {
            if (err?.estado_llamada || err?.observacion_llamada)
              return setAlert(
                true,
                "El estado de llamada y su observación son requeridos",
                AlertSeverityEnum.error,
              );
            handleErrorForm(err as ErrorMessagesForm);
          })();
        }}
      />
    </>
  );
};

export default ConfirmPreagendamiento;
